module.exports = __webpack_public_path__ + "img/26.1fca843a.png";